
import { selectPlanPermissions } from '@/store/user/user.slice'
import { ReactNode, useCallback } from 'react'
import { useSelector } from 'react-redux'

interface OPermissionProps {
  children: ReactNode
  permissions: string[]
}

export function OPermission({ children, permissions }: OPermissionProps) {
  const planPermissions = useSelector(selectPlanPermissions);

  if (!permissions.length) {
    return children
  }
  if (!planPermissions) return null;
  

  const hasPermission = permissions.every(permission => planPermissions.includes(permission))

  if (!hasPermission) {
    return null
  }

  return children
}

interface OPermissionAndElseProps extends OPermissionProps {
  elseElem: ReactNode
}

export function OPermissionAndElse({ children, permissions, elseElem }: OPermissionAndElseProps) {
  const planPermissions = useSelector(selectPlanPermissions);

  if (!permissions.length) {
    return children
  }
  if (!planPermissions) return null;
  

  const hasPermission = permissions.every(permission => planPermissions.includes(permission))

  if (!hasPermission) {
    return elseElem
  }

  return children
}

export function OHaveAnyPermission({ children, permissions }: OPermissionProps) {
  const planPermissions = useSelector(selectPlanPermissions);

  if (!permissions.length) {
    return children
  }

  if (!planPermissions) return null;
  

  const hasPermission = permissions.some(permission => planPermissions.includes(permission))

  if (!hasPermission) {
    return null
  }

  return children
}

export const useHasPermissions = () => {
  const planPermissions = useSelector(selectPlanPermissions);

  return useCallback((permissions: string[]) => {
    if (permissions.length === 0) return true;
    if (!planPermissions) return false;
    return permissions.every(permission => planPermissions.includes(permission))
  }, [planPermissions])
}